import axios from "axios";
import getToken from "./plugins/fetchToken";

import userActions from "@/bin/aws/userActions";
import store from "@/store";

const URL = process.env.VUE_APP_BASE_URL;
const token = "aristdashboard";

const axios_instance = axios.create({
  baseURL: URL,
  headers: {
    "X-Arist-Client": `${token}`
  }
});
/**
Used to add a token to every request. If there isn't a token, then it appends undefined or null
 */
axios_instance.interceptors.request.use(async config => {
  let token = await getToken();
  //If there isn't a token, don't send an authorization header...
  if (token === null || token === undefined) {
    console.log("Using default config");
    return config;
  }
  config.headers["authorization"] = `${token}`;
  return config;
});

axios_instance.interceptors.response.use(
  async response => {
    // console.log(
    //   response,
    //   401,
    //   Number(response.status) === 401,
    //   !response.config.url.includes("/api/v2/user")
    // );
    if (
      Number(response.status) === 401 &&
      !response.config.url.includes("/api/v2/user")
    ) {
      checkValidUser(response);
    }
    return response;
  },
  error => {
    if (Number(error && error.response ? error.response.status : 0) === 401) {
      checkValidUser();
    }
    return Promise.reject(error);
  }
);

// const { user } = require("./index");

async function checkValidUser(response) {
  try {
    await userActions.getAWSUser();
  } catch (err) {
    console.log("Failed to get AWS User...");
    store.commit("needauth", true);
  }
}
/**
Used to add the client subdomain to local development
 */
axios.defaults.params = {};
// if (process.env.NODE_ENV === "development") {
//   axios.defaults.params["client"] = "demo";
// }
// if (process.env.NODE_ENV === "production") {
//   axios.defaults.params["client"] = "joe";
// }
if (process.env.VUE_APP_DEVELOPMENT_CLIENT != undefined) {
  axios.defaults.params["client"] = String(
    process.env.VUE_APP_DEVELOPMENT_CLIENT
  );
}
console.log(axios_instance.defaults);
console.log(axios.defaults);
export default axios_instance;
